module.exports = __webpack_public_path__ + "static/media/image13.31d49029.png";